// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"245c3853","286":"ffa42f5d","466":"3c6820df","504":"a6690cdf"}[chunkId] + ".chunk.js";
};